import { render, staticRenderFns } from "./MarkIndex.vue?vue&type=template&id=1dca27aa&scoped=true"
import script from "./MarkIndex.vue?vue&type=script&lang=js"
export * from "./MarkIndex.vue?vue&type=script&lang=js"
import style0 from "./MarkIndex.vue?vue&type=style&index=0&id=1dca27aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dca27aa",
  null
  
)

export default component.exports